import { ReportTypeEnums, useReportGoalsQuery } from "@api/graphql/types-and-hooks.tsx";

export const useGoals = ({ reportId }: { reportId?: string }) => {
  const goalsQuery = useReportGoalsQuery(
    {
      id: reportId as string,
      filter: {
        reportType: ReportTypeEnums.InitialAssessment,
      },
    },
    {
      queryKey: ["get-report-goals-query", reportId],
      enabled: !!reportId,
      retry: false,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    },
  );
  return { goalsQuery };
};
